export class SolicitationJustify {
  approved!: boolean;
  disapproved!: boolean;
  justification!: string | null;
  ids: number[] = [];
}
